module.exports = __webpack_public_path__ + "static/media/plus_green.44300f82.svg";